import React from "react";

import UserFilter from "./UserFilter";

import { Button } from "@/components/ui/button";
import {
  ClearFiltersButton,
  DateTimeRangeFilter,
  FilterBarContainer,
  FilterGroup,
} from "@/components/ui/FilterBar";
import { cn } from "@/lib/utils";

export interface ChangelogFilterState {
  selectedDateRange: { start?: string; end?: string } | null;
  selectedUserId: number | null;
  showPendingOnly: boolean;
}

interface FilterBarProps {
  filters: ChangelogFilterState;
  onFiltersChange: (filters: ChangelogFilterState) => void;
  pendingCount?: number;
}

const FilterBar: React.FC<FilterBarProps> = ({ filters, onFiltersChange, pendingCount }) => {
  const hasActiveFilters =
    filters.selectedDateRange !== null ||
    filters.selectedUserId !== null ||
    filters.showPendingOnly;

  const handleDateChange = (range: { start?: string; end?: string } | null) => {
    onFiltersChange({
      ...filters,
      selectedDateRange: range,
    });
  };

  const handleUserChange = (userId: number | null) => {
    onFiltersChange({
      ...filters,
      selectedUserId: userId,
    });
  };

  const handleClearAll = () => {
    onFiltersChange({
      selectedDateRange: null,
      selectedUserId: null,
      showPendingOnly: false,
    });
  };

  const handleTogglePending = () => {
    onFiltersChange({
      ...filters,
      showPendingOnly: !filters.showPendingOnly,
    });
  };

  return (
    <FilterBarContainer>
      <FilterGroup>
        <DateTimeRangeFilter value={filters.selectedDateRange} onChange={handleDateChange} />
        <UserFilter value={filters.selectedUserId} onChange={handleUserChange} />
      </FilterGroup>
      <ClearFiltersButton onClick={handleClearAll} show={hasActiveFilters} />
      {pendingCount !== undefined && pendingCount > 0 && (
        <Button
          variant={filters.showPendingOnly ? "blue" : "blueOutline"}
          size="sm"
          className="ml-auto"
          onClick={handleTogglePending}
        >
          {filters.showPendingOnly ? "Showing Pending" : "Review Changes"}
          <span
            className={cn(
              "ml-1.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-medium",
              filters.showPendingOnly ? "bg-blue-400 text-white" : "bg-blue-100 text-blue-700",
            )}
          >
            {pendingCount}
          </span>
        </Button>
      )}
    </FilterBarContainer>
  );
};

export default FilterBar;
